import { render, staticRenderFns } from "./SocialEnter.vue?vue&type=template&id=21e23fd0&scoped=true&"
import script from "./SocialEnter.vue?vue&type=script&lang=js&"
export * from "./SocialEnter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e23fd0",
  null
  
)

export default component.exports